import SuggestionUseCasesInterface from "./suggestionInterface";
import suggestionRepository from "../../../../infrastructure/repository/impl/suggestion/suggestion_repository";

class SuggestionUseCases implements SuggestionUseCasesInterface {
  async suggestion(title: string, description: string): Promise<void> {
    await suggestionRepository.suggestion(title, description);
  }
}

export default new SuggestionUseCases() as SuggestionUseCasesInterface;
